import { CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import { MICRO_TRANSITION_TIMING } from 'HubStyleTokens/times';
import AppCard from 'ecosystem-marketplace-core/components/cards/AppCard';
import styled from 'styled-components';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
// @ts-expect-error untyped import
import { getIsNewOffering } from 'ecosystem-marketplace-core/utils/offerings';
import { getHasAppCertificationCredential } from 'marketplace-ui-apps-core/common/utils/Certification';
// @ts-expect-error untyped import
import { getListingDetailUrl } from '../../../utils/urls';
import { useSelector } from 'react-redux';
// @ts-expect-error untyped import
import { getIsUngatedForRecommendationsBadge } from '../../../selectors/auth';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRouterLink = styled(UIRouterLink).withConfig({
  displayName: "ResultCard__StyledRouterLink",
  componentId: "e50sxf-0"
})(["display:flex;align-items:stretch;"]);
const StyledAppCard = styled(AppCard).withConfig({
  displayName: "ResultCard__StyledAppCard",
  componentId: "e50sxf-1"
})(["&&{border:2px solid transparent;transition:border ", " ease-out;&:hover{border-color:", ";}}"], MICRO_TRANSITION_TIMING, CALYPSO_MEDIUM);
const ResultCard = ({
  onClick,
  result,
  superCategory
}) => {
  const {
    category,
    companyName,
    credentials,
    firstPublishedAt,
    iconUrl,
    installed,
    installsCount,
    name,
    recommendation,
    slug,
    tagline
  } = result;
  const isUngatedForRecommendationsBadge = useSelector(getIsUngatedForRecommendationsBadge);
  const showIsNewApp = getIsNewOffering(firstPublishedAt);
  const hasRecommendedBadge = !!recommendation && isUngatedForRecommendationsBadge;
  return /*#__PURE__*/_jsx(StyledRouterLink, {
    "data-test-id": "result-card",
    onClick: onClick,
    to: getListingDetailUrl(slug, category, superCategory),
    use: "unstyled",
    children: /*#__PURE__*/_jsx(StyledAppCard, {
      certified: getHasAppCertificationCredential(credentials),
      className: "m-bottom-0",
      companyName: companyName,
      hasRecommendedBadge: hasRecommendedBadge,
      iconUrl: iconUrl,
      installed: installed,
      installsCount: installsCount,
      name: name,
      showIsNewApp: showIsNewApp,
      tagline: tagline
    })
  });
};
export default ResultCard;